const COUNTRY_NAME_ALIASES: Record<string, string> = {
  'Republic of South Africa': 'South Africa',
  'South Africa (ZA)': 'South Africa',
  'Australia (AU)': 'Australia',
  AU: 'Australia',
  AUS: 'Australia',
  'Canada (CA)': 'Canada',
  CA: 'Canada',
  CAN: 'Canada',
  'France (FR)': 'France',
  FR: 'France',
  'Germany (DE)': 'Germany',
  DE: 'Germany',
  'New Zealand (NZ)': 'New Zealand',
  NZ: 'New Zealand',
  'Singapore (SG)': 'Singapore',
  SG: 'Singapore',
  'Japan (JP)': 'Japan',
  JP: 'Japan',
  'United States of America': 'United States',
  USA: 'United States',
  US: 'United States',
  'Great Britain': 'United Kingdom',
  UK: 'United Kingdom',
};

export const normalizeCountryName = (
  countryName: string | null | undefined
): string | null => {
  if (!countryName) return null;

  const trimmed = countryName.trim();
  return COUNTRY_NAME_ALIASES[trimmed] ?? trimmed;
};
